import { successNotification, warningNotification } from "@app/common/components/notifications";
import { useAuthentication } from "@app/store/useAuthtentication";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAnnulDeliveryRequestsService, patchAnnulDeliveryRequestService } from "./services";
import { CancellationDeliveriesFilter, PatchAnnulDeliveryPayload } from "./types";
import { AxiosError } from "axios";
import { IResponse } from "@app/common/types/http";

export function useGetAnnulDeliveryRequests(filters: CancellationDeliveriesFilter, enabled = true) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  const query = useQuery({
    enabled,
    gcTime: 0,
    queryKey: [
      "annulDeliveryRequests",
      filters.page,
      filters.sta_id,
      filters.date_from,
      filters.date_to,
      filters.search
    ],
    queryFn: async () => await getAnnulDeliveryRequestsService(filters, token)
  });

  return {
    data: query.data?.results ?? [],
    rowTotal: query.data?.rowTotal ?? 0,
    refetch: query.refetch,
    isLoading: query.isLoading
  };
}

export function usePatchAnnulDeliveryRequest(onSuccess = async () => {}) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ radId, payload }: { radId: number; payload: PatchAnnulDeliveryPayload }) =>
      await patchAnnulDeliveryRequestService(radId, payload, token),
    onSuccess: async (data) => {
      successNotification(data.message, "Actualizado exitosamente");
      queryClient.invalidateQueries({ queryKey: ["annulDeliveryRequests"] });
      await onSuccess();
    },
    onError: async (error: AxiosError<IResponse>) => {
      warningNotification(error.response?.data?.message, "Intenta de nuevo");
    }
  });
}
